var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackwardarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.621,
    height: 16.243,
    viewBox: "0 0 19.621 16.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Back",
    transform: "translate(2.121 5.121)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    x2: 16,
    transform: "translate(0 3)",
    fill: "none",
    stroke: "#373334",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    x2: 6,
    y2: 6,
    transform: "translate(0 3)",
    fill: "none",
    stroke: "#373334",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    y1: 6,
    x2: 6,
    transform: "translate(0 -3)",
    fill: "none",
    stroke: "#373334",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackwardarrow);
export default __webpack_public_path__ + "static/media/backwardarrow.40d16eff2c9f6cb4d5d1c8249df15d70.svg";
export { ForwardRef as ReactComponent };